import { gql } from "@apollo/client";

export const GET_SUBSCRIPTION_PRODUCTS = gql`
	query GetVariants {
		variants(filter: { canSubscribe: { equalTo: true } }) {
			nodes {
				id
				name
				sku
				product {
					id
					name
					imageSrc
				}
			}
		}
	}
`;
